import { useEffect, useState } from 'react';
import { getMetricsOptions } from '../../services/benchmark';

export const useFilterData = (dataFrame: string, gameCode: string) => {
  const [loading, setLoading] = useState(false);
  const [genreOptions, setGenreOptions] = useState([]);
  const [metricOptions, setMetricOptions] = useState([]);
  const [defaultGameValue, setDefaultGameValue] = useState([]);
  const [defaultGenreValue, setDefaultGenreValue] = useState('');
  const [defaultMetricsValue, setDefaultMetricsValue] = useState([]);


  useEffect(() => {
    setLoading(true);
    getMetricsOptions({
      game_code: gameCode,
      frame_type: dataFrame,
    })
      .then((data) => {
        const {
          genre_list,
          metric_list,
          default_metric_list,
          default_genre_list,
          default_game_list,
        } = data;
        setGenreOptions(genre_list || []);
        setMetricOptions(metric_list || []);
        setDefaultGameValue(default_game_list || []);
        setDefaultGenreValue(default_genre_list?.[0] || '');
        setDefaultMetricsValue(default_metric_list || []);
      })
      .catch((e) => {
        console.log(e);
      }).finally(() => setLoading(false));
  }, []);

  return {
    loading,
    genreOptions,
    metricOptions,
    defaultGameValue,
    defaultGenreValue,
    defaultMetricsValue,
  };
};
